import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { FontNormal } from '@css/fonts';

export const PhoneNumberText = styled('span')(css`
  ${FontNormal(600)};
`);
